import {
  GridActionsCellItem,
  GridActionsCellItemProps,
  GridColDef,
} from "@mui/x-data-grid";

import { ReactElement } from "react";
import DeleteSKUContainer from "../components/DeleteSKUContainer";
import DuplicateSKUContainer from "../components/DuplicateSKUContainer";

export const useSKUsTableColumns = (): {
  columns: GridColDef[];
} => {
  const columns: GridColDef[] = [
    {
      field: "skuNumber",
      headerName: "SKU Number",
      minWidth: 160,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
    },
    {
      field: "configurationName",
      headerName: "Configuration",
      minWidth: 200,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
    },
    {
      field: "nodeCount",
      headerName: "Nodes",
      minWidth: 80,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      renderCell: params => params.value ?? 0,
    },
    {
      field: "skuDataConfigurations",
      headerName: "Devices",
      minWidth: 350,
      flex: 1,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      renderCell: params => {
        const value = params.value;
        try {
          const data = typeof value === "string" ? JSON.parse(value) : value;

          if (!Array.isArray(data)) return "Invalid Data";

          // New format: [{name, models}] — show component names
          const names = data
            .map(item => item?.name)
            .filter(Boolean)
            .join(", ");

          return names || "—";
        } catch (e) {
          return "Invalid Data";
        }
      },
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 140,
      disableColumnMenu: true,
      hideable: false,
      sortable: false,
      type: "actions",
      width: 140,
      getActions: (params): ReactElement<GridActionsCellItemProps>[] => [
        <GridActionsCellItem
          key={`duplicate-${params.row?.rowId}`}
          icon={<DuplicateSKUContainer row={params.row} />}
          label="Duplicate"
          className="actionButton"
          disableRipple
        />,
        <GridActionsCellItem
          key={`delete-${params.row?.rowId}`}
          icon={<DeleteSKUContainer row={params.row} />}
          label="Delete"
          className="actionButton"
          disableRipple
        />,
      ],
    },
  ];

  return { columns };
};
